// Client-only tracker for recently viewed buy orders. Stored in localStorage.
const STORAGE = "wtb-recent-v1";
const MAX = 50;

export function readRecent(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const v = JSON.parse(localStorage.getItem(STORAGE) || "[]");
    return Array.isArray(v) ? v.filter((x): x is string => typeof x === "string") : [];
  } catch {
    return [];
  }
}

export function pushRecent(id: string): void {
  if (typeof window === "undefined" || !id) return;
  try {
    const current = readRecent().filter((x) => x !== id);
    current.unshift(id);
    localStorage.setItem(STORAGE, JSON.stringify(current.slice(0, MAX)));
  } catch {
    // ignore quota / disabled storage
  }
}

export function clearRecent(): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(STORAGE);
  } catch {
    // ignore
  }
}
